import React from 'react';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import { FormControlLabel } from 'material-ui/Form';
import Switch from 'material-ui/Switch';
import AddressBookUtil from '../utils/AddressBookUtil'
import { numHyphen, removalBlank, zenHan, stripNewline, validateAddressExcel, validateAddressExcelItem, validateFollowCallAddressExcelItem } from '../../../utils/validator'
import { SHEET_JSFT } from '../../../constants/Constants'
import DialogModal from '../../common/DialogModal';
import Upload from '../../Icons/Upload'
import HelpIcon from '../../Icons/HelpIcon';
import Tooltip from 'material-ui/Tooltip';
import ChipTextarea from '../../common/ChipTextarea';
import * as moment from 'moment';

const styles = () => ({
  contentContainer: {
    padding: '25px',
    margin: 0,
  },

  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  container: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '35px 0px 55px 0px'
  },

  uploadBtn: {
    color: '#FFFFFF',
    backgroundColor: '#1A65FF',
    fontSize: '15px',
    fontWeight: 400,
    padding: '14px 26px',
    '&:hover': {
      backgroundColor: '#1A65FF',
      opacity: .6,
    },
  },

  disabledUploadBtn: {
    pointerEvents: 'none',
    background: '#F4F6F9',
    color: '#B1B3B9',
    border: '1px solid #D8DBDF',
  },

  hidden: {
    display: 'none',
  },

  importContainer: {
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    padding: '20px',
    width: '100%',
    boxSizing: 'border-box',
  },

  row: {
    padding: '20px 10px 20px 20px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    borderBottom: '1px solid #D8DBDF',
    boxSizing: 'border-box',
  },

  title: {
    textAlign: 'left',
    marginRight: '5px',
  },

  filename: {
    maxWidth: '270px',
    textOverflow: 'hidden',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },

  linkBtn: {
    marginLeft: '10px',
    textDecoration: 'underline',
    cursor: 'pointer',
  },

  flex: {
    flex: 1,
    display: 'flex',
  },

  arrow: {
    position: 'absolute',
    fontSize: 6,
    bottom: 0,
    left: 'calc(50% - 1.5em)',
    marginBottom: '-0.95em',
    width: '3em',
    height: '1em',

    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '1em 1em 0 1em',
      borderColor: `#181819 transparent transparent transparent`,
    },
  },

  tooltip: {
    fontSize: 13,
    maxWidth: '335px',
    backgroundColor: "#181819",
    padding: '12px 15px',
    opacity: 1,
    textAlign: 'left',
  },

  formControlLabel: {
    margin: '-15px',
  },

  chipRoot: {
    width: '300px',
  },

  chipContainer: {
    width: '100%',
  },

});

class AddFromExcelDialog extends React.Component {
  initialState = {
    file: null,
    fileName: '',
    items: [],
    linkCorporation: true,
    tags: []
  }

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  handleUploadClick = () => {
    this.fileUpload.click();
  };

  handleChange = (e) => {
    this.setState({
      linkCorporation: e.target.checked
    })
  }

  handleAddTag = (e) => {
    this.setState({
      tags: e
    })
  }

  handleUpload = () => {
    let items = this.state.items;
    if (this.state.tags.length > 0) {
      items = this.state.items.map(item => {
        item['tags'] = [...item['tags'], ...this.state.tags];
        return item;
      });

      this.setState({
        items: items
      })
    }

    this.props.onUpload(items, this.state.linkCorporation, this.props.isFollowCallAddress, [`${moment().format('YYYY年MM月DD日HH:mm:ss')}(Excel)`]);
    this.props.onFinished();
  }

  handleFile = (event) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: 'array' });
      /* Get first worksheet */
      const wsname = "入力用";
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const header = ["rowIndex", "post_code", "company", "branch", "position", "name", "honorific", "address", "tel", "fax", "email", "tags", "corporate_number"];
      const data = XLSX.utils.sheet_to_json(ws, { header: header, skipHeader: true });

      this.processData(data, e.target.file, e.target.fileName);
    };

    const files = event.target.files;
    if (files && files[0]) {
      reader.fileName = files[0].name;
      reader.file = files[0];
      reader.readAsArrayBuffer(files[0]);
    }
  };

  processData = (data, file, fileName) => {
    if (validateAddressExcel(data, this.props.isFollowCallAddress) === false) {
      this.props.displayNotification(
        <div>
          アップロードできませんでした。専用のひな形をご利用ください。
          <span className={this.props.classes.linkBtn} onClick={() => {
            this.props.isFollowCallAddress ? window.open(process.env.REACT_APP_FOLLOW_CALL_ADDRESS_BOOK_EXCEL) : window.open(process.env.REACT_APP_ADDRESS_BOOK_EXCEL);
          }}>
            ひな形をダウンロード
          </span>
        </div>
        , "ghost");
      return;
    }

    this.setState({
      fileName: '',
      items: [],
    });

    let total = data.length;
    let items = [];

    /* read data by row */
    for (let i = 2; i < total; i++) {
      /* create address item */
      let item = AddressBookUtil.makeAddress(data[i]);
      if (Object.keys(data[i]).length > 1) { // if is a valid row
        //relace hyphen before submitting data
        for (let p in item) {
          if (p === 'post_code' || p === 'tel' || p === 'fax' || p === 'email') {
            item[p] = removalBlank(zenHan(item[p]));
          }
          if (p === 'post_code' || p === 'tel' || p === 'fax') {
            item[p] = numHyphen(item[p]);
          }

          if (p !== 'tags' && p !== 'detail') {
            item[p] = stripNewline(item[p])
          }

          //【refs#3290】ハイフンの置き換えは一旦保留で
          // if (p === 'address') {
          //   item[p] = toHalfWidthHyphen(item[p]);
          // }
        }

        item['detail'] = { 'filename': fileName, 'no': data[i]['rowIndex'] };
        if (this.validateAddressItem(item)) {
          items.push(item);
        }
      }
    }


    this.setState({
      items: items,
      tags: [],
      file: file,
      fileName: fileName,
    })
  };

  // バリデーションをレター送付アドレスかフォローコールアドレスかに応じて実行
  validateAddressItem = (item) => {
    if (this.props.isFollowCallAddress) {
      return validateFollowCallAddressExcelItem(item);
    } else {
      return validateAddressExcelItem(item);
    }
  }

  renderExcelUpload = () => {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <Button onClick={this.handleUploadClick} color="primary" className={classes.uploadBtn}>
          <Upload width={20} height={20} color="#FFFFFF" style={{ marginRight: '5px' }} />
          <Typography variant="subheading" style={{ color: "#FFFFFF" }}> Excelファイルをアップロード </Typography>
          <input
            type="file"
            accept={SHEET_JSFT}
            className={classes.hidden}
            ref={(fileUpload) => { this.fileUpload = fileUpload; }}
            onChange={this.handleFile} />
        </Button>
      </div>
    )
  }

  renderImportSetting = () => {
    const { classes } = this.props;

    return (
      <div className={classes.importContainer}>
        <div className={classes.row}>
          <Typography variant="subheading" className={classNames(classes.title, classes.flex)}>選択したファイル</Typography>
          <Typography variant="body2" className={classes.filename}>{this.state.fileName}</Typography>
          <Typography
            onClick={this.handleUploadClick}
            variant="body1"
            className={classNames('clickable', classes.linkBtn)}>
            変更
          </Typography>
          <input
            type="file"
            accept={SHEET_JSFT}
            className={classes.hidden}
            ref={(fileUpload) => { this.fileUpload = fileUpload; }}
            onChange={this.handleFile}
          />
        </div>
        <div className={classes.row}>
          <Typography variant="subheading" className={classNames(classes.title, classes.flex)}>インポート件数</Typography>
          <Typography variant="body2" className={classes.filename}>{this.state.items.length}件</Typography>
        </div>
        <div className={classes.row}>
          <Typography variant="subheading" className={classes.title} >
            法人番号を紐づける(推奨)
          </Typography>
          <div className={classes.flex} style={{ height: '17px', alignItems: 'center' }}>
            <Tooltip
              placement="top"
              title={
                <React.Fragment>
                  国税庁が公開している法人番号を自動で紐づけることができます。また、送付NGを正確に弾くためには法人番号が必須です。※名称や住所等のデータには一切影響しません。
                  <span className={classes.arrow} />
                </React.Fragment>
              }
              classes={{
                tooltip: classes.tooltip,
              }}
            >
              <HelpIcon width={15} height={15} color="#71737B" />
            </Tooltip>
          </div>

          <FormControlLabel
            control={
              <Switch
                checked={this.state.linkCorporation}
                onChange={this.handleChange}
                value="linkCorporation"
                color="primary"
              />
            }
            className={classes.formControlLabel}
          />
        </div>
        <div className={classes.row} style={{ paddingRight: '0px' }}>
          <Typography variant="subheading" className={classes.title}>新しいリストを作成</Typography>
          <div className={classes.flex} style={{ height: '17px', alignItems: 'center' }}>
            <Tooltip
              placement="top"
              title={
                <React.Fragment>
                  後から検索しやすいように、インポートするアドレスに一括でリストを作成します。
                  <span className={classes.arrow} />
                </React.Fragment>
              }
              classes={{
                tooltip: classes.tooltip,
              }}
            >
              <HelpIcon width={15} height={15} color="#71737B" />
            </Tooltip>
          </div>
          <ChipTextarea
            chips={this.state.tags}
            onChange={this.handleAddTag}
            placeholder="新しく作成するリスト名を入力してください"
            classes={{
              root: classes.chipRoot,
              container: classes.chipContainer,
            }}
          />
        </div>

        <Button
          onClick={this.handleUpload}
          color="primary"
          className={classNames(classes.uploadBtn, this.state.items.length === 0 ? classes.disabledUploadBtn : '')}
          style={{ margin: "40px 0px 30px 0px" }}
          disabled={this.state.items.length === 0}
        >
          インポートを開始
        </Button>
      </div>
    )
  }

  render() {
    const { classes } = this.props;

    return (
      <DialogModal
        classes={{
          contentContainer: classes.contentContainer,
          paper: classes.paper,
        }}
        open={this.props.isOpen}
        maxWidth={false}
        onClose={this.props.toggleDialog}
        title={this.state.file ? "インポート設定" : "Excelからインポート"}
      >
        {this.state.file ? this.renderImportSetting() : this.renderExcelUpload()}
      </DialogModal>
    );
  }
}

AddFromExcelDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onUpload: PropTypes.func.isRequired,
  onFinished: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  displayNotification: PropTypes.func.isRequired,
  isFollowCallAddress: PropTypes.bool,
};

export default withStyles(styles)(AddFromExcelDialog);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/AddFromExcelDialog.jsx